<div *ngIf="notificationData$ | async as notificationData" [attr.automation-id]="'notificationData'" class="popup_top_index">
    <ng-container *ngIf="notificationData.length; else noContent">
        <header>
            <span class="title"
                >{{ 'Layouts.Masthead.USER_NOTIFICATIONS.mentionedIn' | translate }}
                <b>{{ 'Layouts.Masthead.USER_NOTIFICATIONS.newComments' | translate: { count: notificationData.length } }}</b></span
            >
            <div class="clear" (click)="clearAll(notificationData[0])">
                <p-icon name="eraser"></p-icon>
                {{ 'Layouts.Masthead.USER_NOTIFICATIONS.clearAll' | translate }}
            </div>
        </header>
        <div class="content">
            <p-user-item *ngFor="let item of notificationData" [item]="item"></p-user-item>
        </div>
    </ng-container>

    <ng-template #noContent>
        <header>
            <span class="title"
                >{{ 'Layouts.Masthead.USER_NOTIFICATIONS.youHave' | translate }}
                <b>{{ 'Layouts.Masthead.USER_NOTIFICATIONS.newMentions' | translate: { count: 0 } }}</b>
            </span>
        </header>
        <div class="empty">
            <img src="/assets/icons/svgs/userNotifications_emptyState.svg" />
        </div>
    </ng-template>
</div>
